import { AxiosInstance } from 'axios'

import { AddressByZipCode } from '@modules/addresses/types/addresses'
import { FindAddressByZipCodeRequest } from '@modules/addresses/types/requests'

export class AddressesService {
  private instance: AxiosInstance

  constructor(instance: AxiosInstance) {
    this.instance = instance
  }

  // ---------- Addresses ----------

  async findByZipCode(data: FindAddressByZipCodeRequest): Promise<AddressByZipCode> {
    const { zipCode } = data

    const response = await this.instance.get(`/addresses/zip-code/${zipCode}`)

    return response.data
  }
}

export const addressesService = (instance: AxiosInstance) => new AddressesService(instance)
